import React, { useEffect, useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { DEFAULT_ITEMS_PER_PAGE } from "../../../constants/table";
import ReactPaginate from "react-paginate";
import IconEmbeddedButton from "../../ui/IconEmbeddedButton";
import { CSVLink } from "react-csv";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { getCurrentDateTime } from "../../../helpers/date";
import { useSignalEffect } from "@preact/signals-react";
import { reportRunning } from "../Reports";

let itemsPerPage = DEFAULT_ITEMS_PER_PAGE;

const DataTable = ({ tableHeadings, tableData, title = null, hideTitle = false, hideDownload = false, overrideItemsPerPage }: any) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(Math.ceil(tableData.length / (overrideItemsPerPage ?? itemsPerPage)));
  const [currentData, setCurrentData] = useState(tableData.slice(0, overrideItemsPerPage ?? itemsPerPage));
  const [rowsPerPage, setRowsPerPage] = useState<number>(0);
  const [reportTitle, setReportTitle] = useState<string>("");

  useSignalEffect(() => {
    if (reportRunning.value && tableData) {
      let rows = tableData.length;
      setRowsPerPage(rows);
    } else {
      let rows = overrideItemsPerPage ?? itemsPerPage;
      setRowsPerPage(rows);
    }
  });

  useEffect(() => {
    setCurrentPage(0);
    if (rowsPerPage > 0) {
      setPageCount(Math.ceil(tableData.length / rowsPerPage));
      setCurrentData(tableData.slice(0, rowsPerPage));
      const rptTitle = title?.replace(" ", "_").toLowerCase();
      setReportTitle(rptTitle);
    }
  }, [tableHeadings, tableData, title, rowsPerPage]);

  const getNestedValue = (obj: any, path: string) => {
    return path.split(".").reduce((acc, key) => acc?.[key], obj);
  };

  const onClickChangePage = (e: any) => {
    setCurrentPage(e);
    let offset = e * rowsPerPage;
    setCurrentData(tableData.slice(offset, offset + rowsPerPage));
  };

  return (
    <>
      <Row>
        <Col>{!hideTitle && <h5 className="app-header-text">{title}</h5>}</Col>
        {reportRunning.value === false && (
          <Col className="text-end">
            {tableData && tableData.length > 0 && !hideDownload && (
              <CSVLink
                id="download-button"
                data={tableData}
                headers={tableHeadings}
                filename={`${reportTitle}_${getCurrentDateTime(true)}.csv`}
                style={{ display: "inline-block" }}
                target="_blank"
              >
                <IconEmbeddedButton tooltipText="Data Export" icon={faDownload} />
              </CSVLink>
            )}
          </Col>
        )}
      </Row>

      <Row className="mb-5">
        <Col xs={12}>
          <div style={{ overflowX: "auto" }}>
            <Table striped>
              <thead>
                <tr>{tableHeadings?.map((heading: any) => !heading?.hide && <th key={heading?.key}>{heading?.label}</th>)}</tr>
              </thead>
              <tbody>
                {currentData?.map((row: any, rowIndex: number) => (
                  <tr key={rowIndex}>
                    {tableHeadings?.map(
                      (heading: any) =>
                        !heading?.hide && (
                          <td className="text-capitalize" key={heading?.key}>
                            {getNestedValue(row, heading?.key)}
                          </td>
                        ),
                    )}
                  </tr>
                ))}
                {tableData.length === 0 && (
                  <tr>
                    <td colSpan={tableHeadings.length} className="text-center">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            {pageCount > 1 && (
              <div id="pagination" style={{ position: "relative", zIndex: 0 }}>
                <ReactPaginate
                  previousLabel={"← Previous"}
                  nextLabel={"Next →"}
                  pageCount={pageCount}
                  onPageChange={(event: { selected: number }) => onClickChangePage(event.selected)}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  activeClassName={"active"}
                  forcePage={currentPage}
                />
              </div>
            )}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default DataTable;
